const ADVOCATE = "advocate";
const ADVOCATE_ACTION = "advocate/action";
const ADVOCATE_ALL = "advocate/all";
const CANDIDATE = "candidate-new";
const CANDIDATE_IMAGE = "candidate-new/image"
const LEGISLATOR = "legislator-new";
const REGISTER_TO_VOTE = "register-to-vote/paper";
const SEARCH_CANDIDATES = "search/candidates";
const SEARCH_LEGISLATORS = "search/legislators";
const VOTER_INFORMATION = "voter-information-new";

export default {
  ADVOCATE,
  ADVOCATE_ACTION,
  ADVOCATE_ALL,
  CANDIDATE,
  CANDIDATE_IMAGE,
  LEGISLATOR,
  REGISTER_TO_VOTE,
  SEARCH_CANDIDATES,
  SEARCH_LEGISLATORS,
  VOTER_INFORMATION
};
